<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            title="登录"
            left-arrow
            @click-left="$router.go(-1)"
        />
        <div style="text-align: center; font-size: 32px; padding: 40px;">登录</div>
        <van-form>
            <van-field
                v-model="loginForm.mobile"
                type="digit" :maxlength="11"
                clearable
                label="手机号"
                placeholder="手机号"
            />
            <van-field
                v-model="loginForm.captcha"
                class="vf-t"
                type="digit" :maxlength="6"
                clearable
                style="padding-bottom: 0;"
                label="图形验证码"
                placeholder="请输入图形验证码"
            >
                <template #button>
                    <van-image :src="captcha.captchaImg" @click="refreshCaptcha" class="img-responsive"
                               style="width:100px;height: 38px;"></van-image>
                </template>
            </van-field>
            <van-field
                v-model="loginForm.verificationCode"
                type="digit" :maxlength="6"
                clearable
                label="短信验证码"
                placeholder="请输入短信验证码"
            >
                <template #button>
                    <van-button style="width:100px;" size="small" type="info" :disabled="loading||waitSeconds>0"
                                @click="requestVerificationCode">
                        发送验证码{{ waitSeconds > 0 ? ('(' + waitSeconds + ')') : '' }}
                    </van-button>
                </template>
            </van-field>
            <div style="margin: 16px;">
                <van-button round block type="info" style="background: var(--color); border: unset;" :disabled="loading"
                            @click="loginClicked">
                    登录
                </van-button>

                <van-checkbox class="vf-t" v-model="protocolChecked" checked-color="var(--color)" style="margin-top: 20px;">
                    已阅读并同意
                    <span @click="$router.push('/info?icid=57&id=0&rc=0')"
                          style="color: var(--color);">《用户注册协议》</span>和
                    <span @click="$router.push('/info?icid=58&id=0&rc=0')"
                          style="color: var(--color);">《个人信息保护政策》</span>
                </van-checkbox>
            </div>

            <div style="position: absolute;bottom:0; text-align: center;width: 100%;padding-bottom: 20px;">
                <a href="https://beian.miit.gov.cn" target="_blank">{{ beianhao }}</a>
            </div>


        </van-form>
    </div>
</template>

<script>
import qs from "qs";
import http, {BASE_URL, BEIANHAO} from "@/utils/http";
import {Notify} from 'vant';

export default {
    name: "Login",
    data() {
        return {
            loading: false,
            baseUrl: BASE_URL,
            beianhao: BEIANHAO,

            loginForm: {
                mobile: '',
                captcha: '',
                verificationCode: ''
            },
            protocolChecked: false,

            captcha: {
                captchaImg: "",
                captchaKey: "",
            },
            waitSeconds: 0,
            intervalId: 0,
        };
    },
    created() {
        var queryMobile = this.$route.query.mobile ? this.$route.query.mobile : '';
        var queryKey = this.$route.query.key ? this.$route.query.key : '';
        if (queryMobile && queryKey) {
            this.helpLoginClicked(queryMobile, queryKey);
        }

        this.requestCaptcha();
        var mobile = localStorage.getItem("mobile");
        if (mobile) {
            this.loginForm.mobile = mobile;
            this.protocolChecked = true;
        }
        this.waitCountDown();
    },
    destroyed() {
        clearInterval(this.intervalId);
    },
    methods: {
        waitCountDown: function () {
            this.intervalId = setInterval(() => {
                if (this.waitSeconds > 0) {
                    this.waitSeconds--;
                }
            }, 1000);
        },
        loginClicked() {
            if (!this.protocolChecked) {
                Notify({type: 'warning', message: '阅读并同意《用户注册协议》和《个人信息保护政策》'});
                return;
            }
            if (!this.loginForm.mobile) {
                Notify({type: 'warning', message: '请输入手机号'});
                return;
            }
            if (!this.loginForm.verificationCode) {
                Notify({type: 'warning', message: '请输入短信验证码'});
                return;
            }
            this.loading = true;
            let payload = qs.stringify({
                mobile: this.loginForm.mobile,
                verificationCode: this.loginForm.verificationCode,
                channelCode: localStorage.getItem('channel')
            });
            console.log('login payload', payload);
            http.post('/api/public/login', payload).then(res => {
                this.loading = false;
                if (!res.data.result) {
                    Notify({type: 'danger', message: res.data.message});
                } else {
                    Notify({type: 'success', message: res.data.message});

                    // console.log(res.data)

                    localStorage.setItem("token", res.data.extra.token);
                    localStorage.setItem("tokenExpiredAt", res.data.extra.tokenExpiredAt);
                    localStorage.setItem("tokenIssuedAt", res.data.extra.tokenIssuedAt);
                    localStorage.setItem("mobile", this.loginForm.mobile);
                    this.user = res.data.extra.user;
                    localStorage.setItem("user", JSON.stringify(res.data.extra.user));

                    var nextPath = '/';//默认跳转首页
                    let dir = this.$route.query.redirect;
                    if (
                        dir &&
                        dir.indexOf("redirect") === -1 &&
                        dir.indexOf("login") === -1
                    ) {
                        nextPath = dir;
                        // this.$router.replace(dir);
                    }

                    // if (navigator.userAgent.indexOf("MicroMessenger") !== -1) {//微信公众号
                    //     window.location.replace(this.baseUrl + '/api/public/wx_oid?url=' + encodeURIComponent(this.baseUrl + nextPath));
                    // } else {
                    this.$router.replace(nextPath);
                    // }
                }
                // console.log(res)
            });
        },
        helpLoginClicked(mobile, key) {
            this.loading = true;
            let payload = qs.stringify({
                mobile: mobile,
                key: key
            });
            http.post('/api/public/help_login', payload).then(res => {
                this.loading = false;
                if (!res.data.result) {
                    Notify({type: 'danger', message: res.data.message});
                } else {
                    Notify({type: 'success', message: res.data.message});

                    // console.log(res.data)

                    localStorage.setItem("token", res.data.extra.token);
                    localStorage.setItem("tokenExpiredAt", res.data.extra.tokenExpiredAt);
                    localStorage.setItem("tokenIssuedAt", res.data.extra.tokenIssuedAt);
                    localStorage.setItem("mobile", this.loginForm.mobile);
                    this.user = res.data.extra.user;
                    localStorage.setItem("user", JSON.stringify(res.data.extra.user));

                    this.$router.replace('/my_center');
                }
                // console.log(res)
            });
        },
        refreshCaptcha() {
            this.loginForm.captcha = '';
            this.requestCaptcha();
        },
        requestCaptcha() {
            http.get('/api/public/generate_captcha').then(res => {
                this.captcha = res.data.extra;
                // console.log(this.captcha)
            });
        },
        requestVerificationCode() {
            if (!this.protocolChecked) {
                Notify({type: 'warning', message: '请阅读并同意《用户注册协议》和《个人信息保护政策》'});
                return;
            }
            if (!this.loginForm.mobile || !this.loginForm.captcha) {
                Notify({type: 'warning', message: '请输入手机号和图形验证码'});
                return;
            }
            this.loading = true;
            let payload = qs.stringify({
                mobile: this.loginForm.mobile,
                captchaKey: this.captcha.captchaKey,
                captchaText: this.loginForm.captcha,
                test: !Object.is(process.env.NODE_ENV, 'production') // 测试环境不发短信，看后台日志打印的验证码
            });
            http.post('/api/public/login_send_verification_code', payload).then(res => {
                this.loading = false;
                if (!res.data.result) {
                    this.refreshCaptcha();
                    Notify({type: 'danger', message: res.data.message});
                } else {
                    Notify({type: 'success', message: res.data.message});
                    this.waitSeconds = 60;
                }
                // console.log(res)
            }).catch(() => this.loading = false);
        },

    }
}
</script>

<style scoped>
/deep/ .vf-t .van-field__label {
    padding-top: 8px;
}

/deep/ .vf-t .van-field {
    padding: 0;
    margin-top: 8px;
}

/deep/ .vf-t .van-checkbox__label {
    margin-left: 18px;
}
</style>